module.exports = __webpack_public_path__ + "images/img-3IMTKeF.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/en/3.png
// module id = 2323
// module chunks = 0